const tokens = {
  "colors.border.active": {
    "value": "var(--colors-border-active)",
    "variable": "var(--colors-border-active)"
  },
  "colors.border.disabled": {
    "value": "var(--colors-border-disabled)",
    "variable": "var(--colors-border-disabled)"
  },
  "colors.border.focus": {
    "value": "var(--colors-border-focus)",
    "variable": "var(--colors-border-focus)"
  },
  "colors.border.hover": {
    "value": "var(--colors-border-hover)",
    "variable": "var(--colors-border-hover)"
  },
  "colors.border.interactive": {
    "value": "var(--colors-border-interactive)",
    "variable": "var(--colors-border-interactive)"
  },
  "colors.border.neutral": {
    "value": "var(--colors-border-neutral)",
    "variable": "var(--colors-border-neutral)"
  },
  "colors.brand.beige": {
    "value": "var(--colors-brand-beige)",
    "variable": "var(--colors-brand-beige)"
  },
  "colors.brand.citrus": {
    "value": "var(--colors-brand-citrus)",
    "variable": "var(--colors-brand-citrus)"
  },
  "colors.brand.cream": {
    "value": "var(--colors-brand-cream)",
    "variable": "var(--colors-brand-cream)"
  },
  "colors.brand.grey": {
    "value": "var(--colors-brand-grey)",
    "variable": "var(--colors-brand-grey)"
  },
  "colors.brand.leaf": {
    "value": "var(--colors-brand-leaf)",
    "variable": "var(--colors-brand-leaf)"
  },
  "colors.brand.lichen": {
    "value": "var(--colors-brand-lichen)",
    "variable": "var(--colors-brand-lichen)"
  },
  "colors.brand.midnight": {
    "value": "var(--colors-brand-midnight)",
    "variable": "var(--colors-brand-midnight)"
  },
  "colors.brand.pine": {
    "value": "var(--colors-brand-pine)",
    "variable": "var(--colors-brand-pine)"
  },
  "colors.brand.red": {
    "value": "var(--colors-brand-red)",
    "variable": "var(--colors-brand-red)"
  },
  "colors.brand.rust": {
    "value": "var(--colors-brand-rust)",
    "variable": "var(--colors-brand-rust)"
  },
  "colors.brand.sky": {
    "value": "var(--colors-brand-sky)",
    "variable": "var(--colors-brand-sky)"
  },
  "colors.brand.white": {
    "value": "var(--colors-brand-white)",
    "variable": "var(--colors-brand-white)"
  },
  "colors.button.primary.surface": {
    "value": "var(--colors-button-primary-surface)",
    "variable": "var(--colors-button-primary-surface)"
  },
  "colors.content.contrast": {
    "value": "var(--colors-content-contrast)",
    "variable": "var(--colors-content-contrast)"
  },
  "colors.content.disabled": {
    "value": "var(--colors-content-disabled)",
    "variable": "var(--colors-content-disabled)"
  },
  "colors.content.link": {
    "value": "var(--colors-content-link)",
    "variable": "var(--colors-content-link)"
  },
  "colors.content.onaccent": {
    "value": "var(--colors-content-onaccent)",
    "variable": "var(--colors-content-onaccent)"
  },
  "colors.content.primary": {
    "value": "var(--colors-content-primary)",
    "variable": "var(--colors-content-primary)"
  },
  "colors.content.secondary": {
    "value": "var(--colors-content-secondary)",
    "variable": "var(--colors-content-secondary)"
  },
  "colors.content.tertiary": {
    "value": "var(--colors-content-tertiary)",
    "variable": "var(--colors-content-tertiary)"
  },
  "colors.interactive.disabled": {
    "value": "var(--colors-interactive-disabled)",
    "variable": "var(--colors-interactive-disabled)"
  },
  "colors.interactive.neutral": {
    "value": "var(--colors-interactive-neutral)",
    "variable": "var(--colors-interactive-neutral)"
  },
  "colors.interactive.primary": {
    "value": "var(--colors-interactive-primary)",
    "variable": "var(--colors-interactive-primary)"
  },
  "colors.interactive.secondary": {
    "value": "var(--colors-interactive-secondary)",
    "variable": "var(--colors-interactive-secondary)"
  },
  "colors.interactive.accent.active": {
    "value": "var(--colors-interactive-accent-active)",
    "variable": "var(--colors-interactive-accent-active)"
  },
  "colors.interactive.accent.default": {
    "value": "var(--colors-interactive-accent-default)",
    "variable": "var(--colors-interactive-accent-default)"
  },
  "colors.interactive.accent.focus": {
    "value": "var(--colors-interactive-accent-focus)",
    "variable": "var(--colors-interactive-accent-focus)"
  },
  "colors.interactive.accent.hover": {
    "value": "var(--colors-interactive-accent-hover)",
    "variable": "var(--colors-interactive-accent-hover)"
  },
  "colors.static.black": {
    "value": "var(--colors-static-black)",
    "variable": "var(--colors-static-black)"
  },
  "colors.static.white": {
    "value": "var(--colors-static-white)",
    "variable": "var(--colors-static-white)"
  },
  "colors.status.negative.active": {
    "value": "var(--colors-status-negative-active)",
    "variable": "var(--colors-status-negative-active)"
  },
  "colors.status.negative.bold": {
    "value": "var(--colors-status-negative-bold)",
    "variable": "var(--colors-status-negative-bold)"
  },
  "colors.status.negative.focus": {
    "value": "var(--colors-status-negative-focus)",
    "variable": "var(--colors-status-negative-focus)"
  },
  "colors.status.negative.hover": {
    "value": "var(--colors-status-negative-hover)",
    "variable": "var(--colors-status-negative-hover)"
  },
  "colors.status.negative.subtle": {
    "value": "var(--colors-status-negative-subtle)",
    "variable": "var(--colors-status-negative-subtle)"
  },
  "colors.status.positive.bold": {
    "value": "var(--colors-status-positive-bold)",
    "variable": "var(--colors-status-positive-bold)"
  },
  "colors.status.positive.subtle": {
    "value": "var(--colors-status-positive-subtle)",
    "variable": "var(--colors-status-positive-subtle)"
  },
  "colors.status.warning.bold": {
    "value": "var(--colors-status-warning-bold)",
    "variable": "var(--colors-status-warning-bold)"
  },
  "colors.status.warning.subtle": {
    "value": "var(--colors-status-warning-subtle)",
    "variable": "var(--colors-status-warning-subtle)"
  },
  "colors.surface.accent": {
    "value": "var(--colors-surface-accent)",
    "variable": "var(--colors-surface-accent)"
  },
  "colors.surface.background": {
    "value": "var(--colors-surface-background)",
    "variable": "var(--colors-surface-background)"
  },
  "colors.surface.base": {
    "value": "var(--colors-surface-base)",
    "variable": "var(--colors-surface-base)"
  },
  "colors.surface.neutral": {
    "value": "var(--colors-surface-neutral)",
    "variable": "var(--colors-surface-neutral)"
  },
  "colors.surface.overlay": {
    "value": "var(--colors-surface-overlay)",
    "variable": "var(--colors-surface-overlay)"
  },
  "colors.surface.raised": {
    "value": "var(--colors-surface-raised)",
    "variable": "var(--colors-surface-raised)"
  },
  "radii.none": {
    "value": "0px",
    "variable": "var(--radii-none)"
  },
  "radii.tiny": {
    "value": "4px",
    "variable": "var(--radii-tiny)"
  },
  "radii.xxsmall": {
    "value": "8px",
    "variable": "var(--radii-xxsmall)"
  },
  "radii.xsmall": {
    "value": "10px",
    "variable": "var(--radii-xsmall)"
  },
  "radii.small": {
    "value": "12px",
    "variable": "var(--radii-small)"
  },
  "radii.medium": {
    "value": "16px",
    "variable": "var(--radii-medium)"
  },
  "radii.large": {
    "value": "20px",
    "variable": "var(--radii-large)"
  },
  "radii.xlarge": {
    "value": "32px",
    "variable": "var(--radii-xlarge)"
  },
  "radii.full": {
    "value": "999px",
    "variable": "var(--radii-full)"
  },
  "spacing.none": {
    "value": "0px",
    "variable": "var(--spacing-none)"
  },
  "spacing.micro": {
    "value": "2px",
    "variable": "var(--spacing-micro)"
  },
  "spacing.tiny": {
    "value": "4px",
    "variable": "var(--spacing-tiny)"
  },
  "spacing.xsmall": {
    "value": "8px",
    "variable": "var(--spacing-xsmall)"
  },
  "spacing.small": {
    "value": "12px",
    "variable": "var(--spacing-small)"
  },
  "spacing.medium": {
    "value": "16px",
    "variable": "var(--spacing-medium)"
  },
  "spacing.large": {
    "value": "24px",
    "variable": "var(--spacing-large)"
  },
  "spacing.xlarge": {
    "value": "32px",
    "variable": "var(--spacing-xlarge)"
  },
  "spacing.2xlarge": {
    "value": "48px",
    "variable": "var(--spacing-2xlarge)"
  },
  "spacing.3xlarge": {
    "value": "56px",
    "variable": "var(--spacing-3xlarge)"
  },
  "spacing.4xlarge": {
    "value": "80px",
    "variable": "var(--spacing-4xlarge)"
  },
  "spacing.5xlarge": {
    "value": "100px",
    "variable": "var(--spacing-5xlarge)"
  },
  "spacing.full": {
    "value": "100%",
    "variable": "var(--spacing-full)"
  },
  "sizes.none": {
    "value": "0px",
    "variable": "var(--sizes-none)"
  },
  "sizes.micro": {
    "value": "2px",
    "variable": "var(--sizes-micro)"
  },
  "sizes.tiny": {
    "value": "4px",
    "variable": "var(--sizes-tiny)"
  },
  "sizes.xsmall": {
    "value": "8px",
    "variable": "var(--sizes-xsmall)"
  },
  "sizes.small": {
    "value": "12px",
    "variable": "var(--sizes-small)"
  },
  "sizes.medium": {
    "value": "16px",
    "variable": "var(--sizes-medium)"
  },
  "sizes.large": {
    "value": "24px",
    "variable": "var(--sizes-large)"
  },
  "sizes.xlarge": {
    "value": "32px",
    "variable": "var(--sizes-xlarge)"
  },
  "sizes.2xlarge": {
    "value": "48px",
    "variable": "var(--sizes-2xlarge)"
  },
  "sizes.3xlarge": {
    "value": "56px",
    "variable": "var(--sizes-3xlarge)"
  },
  "sizes.4xlarge": {
    "value": "80px",
    "variable": "var(--sizes-4xlarge)"
  },
  "sizes.5xlarge": {
    "value": "100px",
    "variable": "var(--sizes-5xlarge)"
  },
  "sizes.full": {
    "value": "100%",
    "variable": "var(--sizes-full)"
  },
  "sizes.breakpoint-tablet": {
    "value": "768px",
    "variable": "var(--sizes-breakpoint-tablet)"
  },
  "sizes.breakpoint-desktop": {
    "value": "1200px",
    "variable": "var(--sizes-breakpoint-desktop)"
  },
  "sizes.breakpoint-wideDesktop": {
    "value": "1600px",
    "variable": "var(--sizes-breakpoint-wide-desktop)"
  },
  "borderWidths.none": {
    "value": "0px",
    "variable": "var(--border-widths-none)"
  },
  "borderWidths.small": {
    "value": "1px",
    "variable": "var(--border-widths-small)"
  },
  "borderWidths.medium": {
    "value": "2px",
    "variable": "var(--border-widths-medium)"
  },
  "blurs.none": {
    "value": "0px",
    "variable": "var(--blurs-none)"
  },
  "blurs.medium": {
    "value": "5px",
    "variable": "var(--blurs-medium)"
  },
  "blurs.large": {
    "value": "20px",
    "variable": "var(--blurs-large)"
  },
  "zIndex.base": {
    "value": 0,
    "variable": "var(--z-index-base)"
  },
  "zIndex.raised": {
    "value": 1,
    "variable": "var(--z-index-raised)"
  },
  "zIndex.elevated": {
    "value": 100,
    "variable": "var(--z-index-elevated)"
  },
  "zIndex.header": {
    "value": 200,
    "variable": "var(--z-index-header)"
  },
  "zIndex.drawer": {
    "value": 1000,
    "variable": "var(--z-index-drawer)"
  },
  "zIndex.dialog": {
    "value": 2000,
    "variable": "var(--z-index-dialog)"
  },
  "zIndex.popover": {
    "value": 3000,
    "variable": "var(--z-index-popover)"
  },
  "zIndex.toast": {
    "value": 4000,
    "variable": "var(--z-index-toast)"
  },
  "zIndex.tooltip": {
    "value": 5000,
    "variable": "var(--z-index-tooltip)"
  },
  "shadows.none": {
    "value": "none",
    "variable": "var(--shadows-none)"
  },
  "shadows.small": {
    "value": "0px 1px 3px 0.2px rgba(0, 0, 0, 0.1)",
    "variable": "var(--shadows-small)"
  },
  "shadows.medium": {
    "value": "0px 2px 6px 0px rgba(14, 15, 12, 0.04)",
    "variable": "var(--shadows-medium)"
  },
  "shadows.large": {
    "value": "0px 3px 8px 0px rgba(14, 15, 12, 0.08)",
    "variable": "var(--shadows-large)"
  },
  "cursor.interactive": {
    "value": "pointer",
    "variable": "var(--cursor-interactive)"
  },
  "cursor.disabled": {
    "value": "not-allowed",
    "variable": "var(--cursor-disabled)"
  },
  "borders.none": {
    "value": "0px solid",
    "variable": "var(--borders-none)"
  },
  "borders.small": {
    "value": "1px solid",
    "variable": "var(--borders-small)"
  },
  "borders.medium": {
    "value": "2px solid",
    "variable": "var(--borders-medium)"
  },
  "fonts.monospace": {
    "value": "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace",
    "variable": "var(--fonts-monospace)"
  },
  "fonts.default": {
    "value": "'Inter Variable', Inter, Helvetica, Arial, sans-serif",
    "variable": "var(--fonts-default)"
  },
  "fonts.national": {
    "value": "National2Condensed, 'Inter Variable', Inter, Helvetica, serif",
    "variable": "var(--fonts-national)"
  },
  "breakpoints.tablet": {
    "value": "768px",
    "variable": "var(--breakpoints-tablet)"
  },
  "breakpoints.desktop": {
    "value": "1200px",
    "variable": "var(--breakpoints-desktop)"
  },
  "breakpoints.wideDesktop": {
    "value": "1600px",
    "variable": "var(--breakpoints-wide-desktop)"
  },
  "fontSizes.bodyLargeBold": {
    "value": "var(--font-sizes-body-large-bold)",
    "variable": "var(--font-sizes-body-large-bold)"
  },
  "fontSizes.bodyLargeRegular": {
    "value": "var(--font-sizes-body-large-regular)",
    "variable": "var(--font-sizes-body-large-regular)"
  },
  "fontSizes.bodySmallBold": {
    "value": "var(--font-sizes-body-small-bold)",
    "variable": "var(--font-sizes-body-small-bold)"
  },
  "fontSizes.bodySmallRegular": {
    "value": "var(--font-sizes-body-small-regular)",
    "variable": "var(--font-sizes-body-small-regular)"
  },
  "fontSizes.caption": {
    "value": "var(--font-sizes-caption)",
    "variable": "var(--font-sizes-caption)"
  },
  "fontSizes.display": {
    "value": "var(--font-sizes-display)",
    "variable": "var(--font-sizes-display)"
  },
  "fontSizes.headline": {
    "value": "var(--font-sizes-headline)",
    "variable": "var(--font-sizes-headline)"
  },
  "fontSizes.labelMedium": {
    "value": "var(--font-sizes-label-medium)",
    "variable": "var(--font-sizes-label-medium)"
  },
  "fontSizes.labelSmall": {
    "value": "var(--font-sizes-label-small)",
    "variable": "var(--font-sizes-label-small)"
  },
  "fontSizes.labelTiny": {
    "value": "var(--font-sizes-label-tiny)",
    "variable": "var(--font-sizes-label-tiny)"
  },
  "fontSizes.promotionLarge": {
    "value": "var(--font-sizes-promotion-large)",
    "variable": "var(--font-sizes-promotion-large)"
  },
  "fontSizes.promotionSmall": {
    "value": "var(--font-sizes-promotion-small)",
    "variable": "var(--font-sizes-promotion-small)"
  },
  "fontSizes.subheadlineLarge": {
    "value": "var(--font-sizes-subheadline-large)",
    "variable": "var(--font-sizes-subheadline-large)"
  },
  "fontSizes.subheadlineSmall": {
    "value": "var(--font-sizes-subheadline-small)",
    "variable": "var(--font-sizes-subheadline-small)"
  },
  "lineHeights.bodyLargeBold": {
    "value": "var(--line-heights-body-large-bold)",
    "variable": "var(--line-heights-body-large-bold)"
  },
  "lineHeights.bodyLargeRegular": {
    "value": "var(--line-heights-body-large-regular)",
    "variable": "var(--line-heights-body-large-regular)"
  },
  "lineHeights.bodySmallBold": {
    "value": "var(--line-heights-body-small-bold)",
    "variable": "var(--line-heights-body-small-bold)"
  },
  "lineHeights.bodySmallRegular": {
    "value": "var(--line-heights-body-small-regular)",
    "variable": "var(--line-heights-body-small-regular)"
  },
  "lineHeights.caption": {
    "value": "var(--line-heights-caption)",
    "variable": "var(--line-heights-caption)"
  },
  "lineHeights.display": {
    "value": "var(--line-heights-display)",
    "variable": "var(--line-heights-display)"
  },
  "lineHeights.headline": {
    "value": "var(--line-heights-headline)",
    "variable": "var(--line-heights-headline)"
  },
  "lineHeights.labelMedium": {
    "value": "var(--line-heights-label-medium)",
    "variable": "var(--line-heights-label-medium)"
  },
  "lineHeights.labelSmall": {
    "value": "var(--line-heights-label-small)",
    "variable": "var(--line-heights-label-small)"
  },
  "lineHeights.labelTiny": {
    "value": "var(--line-heights-label-tiny)",
    "variable": "var(--line-heights-label-tiny)"
  },
  "lineHeights.promotionLarge": {
    "value": "var(--line-heights-promotion-large)",
    "variable": "var(--line-heights-promotion-large)"
  },
  "lineHeights.promotionSmall": {
    "value": "var(--line-heights-promotion-small)",
    "variable": "var(--line-heights-promotion-small)"
  },
  "lineHeights.subheadlineLarge": {
    "value": "var(--line-heights-subheadline-large)",
    "variable": "var(--line-heights-subheadline-large)"
  },
  "lineHeights.subheadlineSmall": {
    "value": "var(--line-heights-subheadline-small)",
    "variable": "var(--line-heights-subheadline-small)"
  },
  "letterSpacings.bodyLargeBold": {
    "value": "var(--letter-spacings-body-large-bold)",
    "variable": "var(--letter-spacings-body-large-bold)"
  },
  "letterSpacings.bodyLargeRegular": {
    "value": "var(--letter-spacings-body-large-regular)",
    "variable": "var(--letter-spacings-body-large-regular)"
  },
  "letterSpacings.bodySmallBold": {
    "value": "var(--letter-spacings-body-small-bold)",
    "variable": "var(--letter-spacings-body-small-bold)"
  },
  "letterSpacings.bodySmallRegular": {
    "value": "var(--letter-spacings-body-small-regular)",
    "variable": "var(--letter-spacings-body-small-regular)"
  },
  "letterSpacings.caption": {
    "value": "var(--letter-spacings-caption)",
    "variable": "var(--letter-spacings-caption)"
  },
  "letterSpacings.display": {
    "value": "var(--letter-spacings-display)",
    "variable": "var(--letter-spacings-display)"
  },
  "letterSpacings.headline": {
    "value": "var(--letter-spacings-headline)",
    "variable": "var(--letter-spacings-headline)"
  },
  "letterSpacings.labelMedium": {
    "value": "var(--letter-spacings-label-medium)",
    "variable": "var(--letter-spacings-label-medium)"
  },
  "letterSpacings.labelSmall": {
    "value": "var(--letter-spacings-label-small)",
    "variable": "var(--letter-spacings-label-small)"
  },
  "letterSpacings.labelTiny": {
    "value": "var(--letter-spacings-label-tiny)",
    "variable": "var(--letter-spacings-label-tiny)"
  },
  "letterSpacings.promotionLarge": {
    "value": "var(--letter-spacings-promotion-large)",
    "variable": "var(--letter-spacings-promotion-large)"
  },
  "letterSpacings.promotionSmall": {
    "value": "var(--letter-spacings-promotion-small)",
    "variable": "var(--letter-spacings-promotion-small)"
  },
  "letterSpacings.subheadlineLarge": {
    "value": "var(--letter-spacings-subheadline-large)",
    "variable": "var(--letter-spacings-subheadline-large)"
  },
  "letterSpacings.subheadlineSmall": {
    "value": "var(--letter-spacings-subheadline-small)",
    "variable": "var(--letter-spacings-subheadline-small)"
  },
  "fontWeights.bodyLargeBold": {
    "value": "var(--font-weights-body-large-bold)",
    "variable": "var(--font-weights-body-large-bold)"
  },
  "fontWeights.bodyLargeRegular": {
    "value": "var(--font-weights-body-large-regular)",
    "variable": "var(--font-weights-body-large-regular)"
  },
  "fontWeights.bodySmallBold": {
    "value": "var(--font-weights-body-small-bold)",
    "variable": "var(--font-weights-body-small-bold)"
  },
  "fontWeights.bodySmallRegular": {
    "value": "var(--font-weights-body-small-regular)",
    "variable": "var(--font-weights-body-small-regular)"
  },
  "fontWeights.caption": {
    "value": "var(--font-weights-caption)",
    "variable": "var(--font-weights-caption)"
  },
  "fontWeights.display": {
    "value": "var(--font-weights-display)",
    "variable": "var(--font-weights-display)"
  },
  "fontWeights.headline": {
    "value": "var(--font-weights-headline)",
    "variable": "var(--font-weights-headline)"
  },
  "fontWeights.labelMedium": {
    "value": "var(--font-weights-label-medium)",
    "variable": "var(--font-weights-label-medium)"
  },
  "fontWeights.labelSmall": {
    "value": "var(--font-weights-label-small)",
    "variable": "var(--font-weights-label-small)"
  },
  "fontWeights.labelTiny": {
    "value": "var(--font-weights-label-tiny)",
    "variable": "var(--font-weights-label-tiny)"
  },
  "fontWeights.promotionLarge": {
    "value": "var(--font-weights-promotion-large)",
    "variable": "var(--font-weights-promotion-large)"
  },
  "fontWeights.promotionSmall": {
    "value": "var(--font-weights-promotion-small)",
    "variable": "var(--font-weights-promotion-small)"
  },
  "fontWeights.subheadlineLarge": {
    "value": "var(--font-weights-subheadline-large)",
    "variable": "var(--font-weights-subheadline-large)"
  },
  "fontWeights.subheadlineSmall": {
    "value": "var(--font-weights-subheadline-small)",
    "variable": "var(--font-weights-subheadline-small)"
  },
  "spacing.-none": {
    "value": "calc(var(--spacing-none) * -1)",
    "variable": "var(--spacing-none)"
  },
  "spacing.-micro": {
    "value": "calc(var(--spacing-micro) * -1)",
    "variable": "var(--spacing-micro)"
  },
  "spacing.-tiny": {
    "value": "calc(var(--spacing-tiny) * -1)",
    "variable": "var(--spacing-tiny)"
  },
  "spacing.-xsmall": {
    "value": "calc(var(--spacing-xsmall) * -1)",
    "variable": "var(--spacing-xsmall)"
  },
  "spacing.-small": {
    "value": "calc(var(--spacing-small) * -1)",
    "variable": "var(--spacing-small)"
  },
  "spacing.-medium": {
    "value": "calc(var(--spacing-medium) * -1)",
    "variable": "var(--spacing-medium)"
  },
  "spacing.-large": {
    "value": "calc(var(--spacing-large) * -1)",
    "variable": "var(--spacing-large)"
  },
  "spacing.-xlarge": {
    "value": "calc(var(--spacing-xlarge) * -1)",
    "variable": "var(--spacing-xlarge)"
  },
  "spacing.-2xlarge": {
    "value": "calc(var(--spacing-2xlarge) * -1)",
    "variable": "var(--spacing-2xlarge)"
  },
  "spacing.-3xlarge": {
    "value": "calc(var(--spacing-3xlarge) * -1)",
    "variable": "var(--spacing-3xlarge)"
  },
  "spacing.-4xlarge": {
    "value": "calc(var(--spacing-4xlarge) * -1)",
    "variable": "var(--spacing-4xlarge)"
  },
  "spacing.-5xlarge": {
    "value": "calc(var(--spacing-5xlarge) * -1)",
    "variable": "var(--spacing-5xlarge)"
  },
  "spacing.-full": {
    "value": "calc(var(--spacing-full) * -1)",
    "variable": "var(--spacing-full)"
  },
  "colors.colorPalette.active": {
    "value": "var(--colors-color-palette-active)",
    "variable": "var(--colors-color-palette-active)"
  },
  "colors.colorPalette.disabled": {
    "value": "var(--colors-color-palette-disabled)",
    "variable": "var(--colors-color-palette-disabled)"
  },
  "colors.colorPalette.focus": {
    "value": "var(--colors-color-palette-focus)",
    "variable": "var(--colors-color-palette-focus)"
  },
  "colors.colorPalette.hover": {
    "value": "var(--colors-color-palette-hover)",
    "variable": "var(--colors-color-palette-hover)"
  },
  "colors.colorPalette.interactive": {
    "value": "var(--colors-color-palette-interactive)",
    "variable": "var(--colors-color-palette-interactive)"
  },
  "colors.colorPalette.neutral": {
    "value": "var(--colors-color-palette-neutral)",
    "variable": "var(--colors-color-palette-neutral)"
  },
  "colors.colorPalette.beige": {
    "value": "var(--colors-color-palette-beige)",
    "variable": "var(--colors-color-palette-beige)"
  },
  "colors.colorPalette.citrus": {
    "value": "var(--colors-color-palette-citrus)",
    "variable": "var(--colors-color-palette-citrus)"
  },
  "colors.colorPalette.cream": {
    "value": "var(--colors-color-palette-cream)",
    "variable": "var(--colors-color-palette-cream)"
  },
  "colors.colorPalette.grey": {
    "value": "var(--colors-color-palette-grey)",
    "variable": "var(--colors-color-palette-grey)"
  },
  "colors.colorPalette.leaf": {
    "value": "var(--colors-color-palette-leaf)",
    "variable": "var(--colors-color-palette-leaf)"
  },
  "colors.colorPalette.lichen": {
    "value": "var(--colors-color-palette-lichen)",
    "variable": "var(--colors-color-palette-lichen)"
  },
  "colors.colorPalette.midnight": {
    "value": "var(--colors-color-palette-midnight)",
    "variable": "var(--colors-color-palette-midnight)"
  },
  "colors.colorPalette.pine": {
    "value": "var(--colors-color-palette-pine)",
    "variable": "var(--colors-color-palette-pine)"
  },
  "colors.colorPalette.red": {
    "value": "var(--colors-color-palette-red)",
    "variable": "var(--colors-color-palette-red)"
  },
  "colors.colorPalette.rust": {
    "value": "var(--colors-color-palette-rust)",
    "variable": "var(--colors-color-palette-rust)"
  },
  "colors.colorPalette.sky": {
    "value": "var(--colors-color-palette-sky)",
    "variable": "var(--colors-color-palette-sky)"
  },
  "colors.colorPalette.white": {
    "value": "var(--colors-color-palette-white)",
    "variable": "var(--colors-color-palette-white)"
  },
  "colors.colorPalette.primary.surface": {
    "value": "var(--colors-color-palette-primary-surface)",
    "variable": "var(--colors-color-palette-primary-surface)"
  },
  "colors.colorPalette.surface": {
    "value": "var(--colors-color-palette-surface)",
    "variable": "var(--colors-color-palette-surface)"
  },
  "colors.colorPalette.contrast": {
    "value": "var(--colors-color-palette-contrast)",
    "variable": "var(--colors-color-palette-contrast)"
  },
  "colors.colorPalette.link": {
    "value": "var(--colors-color-palette-link)",
    "variable": "var(--colors-color-palette-link)"
  },
  "colors.colorPalette.onaccent": {
    "value": "var(--colors-color-palette-onaccent)",
    "variable": "var(--colors-color-palette-onaccent)"
  },
  "colors.colorPalette.primary": {
    "value": "var(--colors-color-palette-primary)",
    "variable": "var(--colors-color-palette-primary)"
  },
  "colors.colorPalette.secondary": {
    "value": "var(--colors-color-palette-secondary)",
    "variable": "var(--colors-color-palette-secondary)"
  },
  "colors.colorPalette.tertiary": {
    "value": "var(--colors-color-palette-tertiary)",
    "variable": "var(--colors-color-palette-tertiary)"
  },
  "colors.colorPalette.accent.active": {
    "value": "var(--colors-color-palette-accent-active)",
    "variable": "var(--colors-color-palette-accent-active)"
  },
  "colors.colorPalette.accent.default": {
    "value": "var(--colors-color-palette-accent-default)",
    "variable": "var(--colors-color-palette-accent-default)"
  },
  "colors.colorPalette.default": {
    "value": "var(--colors-color-palette-default)",
    "variable": "var(--colors-color-palette-default)"
  },
  "colors.colorPalette.accent.focus": {
    "value": "var(--colors-color-palette-accent-focus)",
    "variable": "var(--colors-color-palette-accent-focus)"
  },
  "colors.colorPalette.accent.hover": {
    "value": "var(--colors-color-palette-accent-hover)",
    "variable": "var(--colors-color-palette-accent-hover)"
  },
  "colors.colorPalette.black": {
    "value": "var(--colors-color-palette-black)",
    "variable": "var(--colors-color-palette-black)"
  },
  "colors.colorPalette.negative.active": {
    "value": "var(--colors-color-palette-negative-active)",
    "variable": "var(--colors-color-palette-negative-active)"
  },
  "colors.colorPalette.negative.bold": {
    "value": "var(--colors-color-palette-negative-bold)",
    "variable": "var(--colors-color-palette-negative-bold)"
  },
  "colors.colorPalette.bold": {
    "value": "var(--colors-color-palette-bold)",
    "variable": "var(--colors-color-palette-bold)"
  },
  "colors.colorPalette.negative.focus": {
    "value": "var(--colors-color-palette-negative-focus)",
    "variable": "var(--colors-color-palette-negative-focus)"
  },
  "colors.colorPalette.negative.hover": {
    "value": "var(--colors-color-palette-negative-hover)",
    "variable": "var(--colors-color-palette-negative-hover)"
  },
  "colors.colorPalette.negative.subtle": {
    "value": "var(--colors-color-palette-negative-subtle)",
    "variable": "var(--colors-color-palette-negative-subtle)"
  },
  "colors.colorPalette.subtle": {
    "value": "var(--colors-color-palette-subtle)",
    "variable": "var(--colors-color-palette-subtle)"
  },
  "colors.colorPalette.positive.bold": {
    "value": "var(--colors-color-palette-positive-bold)",
    "variable": "var(--colors-color-palette-positive-bold)"
  },
  "colors.colorPalette.positive.subtle": {
    "value": "var(--colors-color-palette-positive-subtle)",
    "variable": "var(--colors-color-palette-positive-subtle)"
  },
  "colors.colorPalette.warning.bold": {
    "value": "var(--colors-color-palette-warning-bold)",
    "variable": "var(--colors-color-palette-warning-bold)"
  },
  "colors.colorPalette.warning.subtle": {
    "value": "var(--colors-color-palette-warning-subtle)",
    "variable": "var(--colors-color-palette-warning-subtle)"
  },
  "colors.colorPalette.accent": {
    "value": "var(--colors-color-palette-accent)",
    "variable": "var(--colors-color-palette-accent)"
  },
  "colors.colorPalette.background": {
    "value": "var(--colors-color-palette-background)",
    "variable": "var(--colors-color-palette-background)"
  },
  "colors.colorPalette.base": {
    "value": "var(--colors-color-palette-base)",
    "variable": "var(--colors-color-palette-base)"
  },
  "colors.colorPalette.overlay": {
    "value": "var(--colors-color-palette-overlay)",
    "variable": "var(--colors-color-palette-overlay)"
  },
  "colors.colorPalette.raised": {
    "value": "var(--colors-color-palette-raised)",
    "variable": "var(--colors-color-palette-raised)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar